import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useGoogleAuth } from '@questlabs/auth-js';

const GoogleGIcon = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" />
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
  </svg>
);

const GretaAuthControl = ({ textColor = 'text-accent-navy', className = '' }) => {
  const { user, signOut, initialized, loading } = useGoogleAuth();
  const navigate = useNavigate();

  if (!initialized || loading) return null;

  if (!user) {
    return (
      <div className={className}>
        <button
          onClick={() => navigate('/login')}
          className={`group flex items-center bg-transparent rounded-full border border-current/30 backdrop-blur-sm transition-all duration-300 max-w-[36px] hover:max-w-[200px] h-9 overflow-hidden hover:border-current/60 ${textColor}`}
          title="Sign in with Google"
        >
          <span className="flex items-center justify-center w-9 h-9 flex-shrink-0">
            <GoogleGIcon />
          </span>
          <span className={`text-sm font-medium whitespace-nowrap pr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300 ${textColor}`}>
            Sign in with Google
          </span>
        </button>
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {user.picture && (
        <img
          src={user.picture}
          alt={user.name || 'Google account'}
          referrerPolicy="no-referrer"
          className="w-8 h-8 rounded-full object-cover border border-current/20"
        />
      )}
      <span className={`text-xs font-bold max-w-[120px] truncate ${textColor}`}>
        {user.name || user.email}
      </span>
      <button
        onClick={signOut}
        className={`text-[10px] font-black uppercase tracking-widest px-3 py-1.5 rounded-full border border-current/40 transition-all hover:text-red-500 hover:border-red-500/60 ${textColor}`}
      >
        Sign out
      </button>
    </div>
  );
};

export default GretaAuthControl;